export const message = {
  removed: "Curso removido da lista.",
  added: "Curso adicionado à lista.",
  error: "Ocorreu um erro, por favor, tente novamente.",
};
